module.exports = __webpack_public_path__ + "img/bh.4c30ffdd.svg";